  import React from "react";
import { Row, Col } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import utils from "utils";
import api from 'utils/api';
import { setPatientConsultationTab } from "store/slice/consultation-slice";
import { setAppData } from "store/slice/appointment-slice";
import MyAppointmentPatientCard from "./MyAppointmentPatientCard";
import { withTranslation, Trans } from "react-i18next";
import { PRIMARY_LANG } from "Common/constant";
import { LANG_STYLD_EXT } from "Common/constant";
import { TS_STYLD_COMPS } from "Common/constant";
import { connect } from "react-redux";
import "./Appointment.scss";
import CommonButton from "Components/CommonButton";
import { setIsChatOpened, setDoctorSelectedData } from "store/slice/login-slice";
import { AppQuestion,  AppTips } from "Common/ReactIcons";
import Loader from "Components/Loader";
import { CONSTANTS } from "utils/constant";
dayjs.extend(utc);
class AppointmentConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appointmentData: props.location?.state?.data ? props.location?.state?.data : props?.appointmentData || {},
      show_buttons: true,
      role: this.props.user_details?.role,
      isLoading: true,
    };
  }

  handleActions(val, value) {
    if (val == "reschedule") {
      this.setState({ isLoading: true })
      api
        .reschedule_appointment({ appointment_id: value })
        .then((response) => {
          if (response.data?.status == 200) {
            utils.Toast({ type: "success", message: response.data?.message });
            // typeof this.props?.appointmentUpdated == "function" && this.props?.appointmentUpdated();
            let finaldata ={} ;
            finaldata.appointment_message= response.data?.message;
            finaldata.appointment_status= "rescheduled";
            finaldata.appointment_status_label="Pending";
            finaldata.can_cancel = false;
            finaldata.can_reschedule = false;
            this.props.setAppData([])
            this.setState({ appointmentData: {...this.state.appointmentData,...finaldata }});
          }
        })
        .catch(() => { })
        .finally(() => { this.setState({ isLoading: false }); })
    } else if (val == "cancel") {
      this.setState({ isLoading: true })
      let subscription =
        localStorage.getItem("subscription") === null
          ? {}
          : JSON.parse(localStorage.getItem("subscription"));
      api
        .cancel_appointment({
          appointment_id: value,
          // membership_type: subscription?.membership_type,
        })
        .then((res) => {
        

          if (res.data?.status == 200) {
            utils.Toast({ type: "success", message: res.data?.message });
            let finaldata = {};
            finaldata.appointment_message= res.data?.message;
            finaldata.appointment_status= "cancelled";
            finaldata.appointment_status_label="Cancelled";
            finaldata.can_cancel = false;
            finaldata.can_reschedule = false;
            this.props.setAppData([])
            this.setState({ appointmentData: {...this.state.appointmentData,...finaldata }});
          }
          this.setstate({ show_buttons: false });
        })
        .catch(() => { })
        .finally(() => { this.setState({ isLoading: false }); })
    }
  }
  navigateToUpcomingAppointments(){
    this.props.setPatientConsultationTab("upcoming");
    this.props?.history?.push("/logged-in-user/consultation-history")
  }

  handleChatOpen() {
    this.props.setIsChatOpened(true);
  }

  componentWillUnmount(){
     this.props.setAppData([])
  }
  componentDidMount(){

    this.setState({ isLoading: false })
    if (this.props.data.length == 0) {
      this.props.setDoctorSelectedData({
        appointmentStepper: false,
        doctorID: "",
        doctorSelectedData: {},
      });
      this.props.setPatientConsultationTab("schedule");
      this.props?.history?.push("/logged-in-user/consultation-history")
    }
  }
  render() {
    let { t } = this.props;
    const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang
    ? tgtLang + LANG_STYLD_EXT
    : tgtLang;
    return (
      <>
        {this.state.isLoading ? <Loader tgtLangST={tgtLangST}/> :
          <div className="my-appointment-container">
            <div className="my-appointment-main">
              <div className="my-appointment-card-container appointment-confirmation-card">
                <div className="title-appointment-confirmation"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPOINTMENT_WITH,{lng:tgtLangST})}</Trans></div>
                <MyAppointmentPatientCard data={this.state.appointmentData} handleFunction={this.handleActions.bind(this)} show_buttons={this.state.show_buttons} role={this.state.role} />
                <div className="aux-cards">
                <div className="help-virtual-visit-container">
                  <div className="help-virtual-visit-content">
                    <div className="title-with-icon">
                        <AppTips />
                        <div className="title-appointment"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.HELPFUL_TIPS,{lng:tgtLangST})}</Trans></div>
                      </div>
                      <div className="virtual-visit-ul-container">
                        <ul>
                          <li><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.JOIN_VIDEO_CALL,{lng:tgtLangST})}</Trans></li>
                          <li><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.ENSURE_YOUR_FACE,{lng:tgtLangST})}</Trans></li>
                          <li><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CHECK_VIDEO_AUDIO_WRK,{lng:tgtLangST})}</Trans></li>
                          <li><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.ALL_CALLS_POINT,{lng:tgtLangST})}</Trans></li>
                          <li><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.YOU_CAN_ALSO_fACE,{lng:tgtLangST})}</Trans></li>
                        </ul>
                      </div>
                  </div>
                </div>


                <div className="app-detail-ques-container">
                  <div className="app-detail-ques-content">
                    <div className="title-with-icon">
                    <AppQuestion />
                    <div className="title-appointment"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.HAVE_A_QUES,{lng:tgtLangST})}</Trans></div>
                  </div>
                  <div style={{ margin: "4px 8px 4px 28px" }} >
                    <p style={{ margin: "0px"}} className="appointment-ques-txt"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.SIMPLY_SEND_CHAT1,{lng:tgtLangST})}</Trans>{this.props.label_color_theme}<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.SIMPLY_SEND_CHAT2,{lng:tgtLangST})}</Trans></p>
                  </div>
                  </div>
                 {/* <CommonButton className="leave-feedback-btn" disabled={this.props.isChatOpened} onClick={this.handleChatOpen.bind(this)} label={CONSTANTS.CHAT_WITH_US} />  */}
                </div>

                
                </div>
              </div> 
            </div>
            <Row className="bottom-content appointment-detail-card-bottom-button">
              <Col><CommonButton className="common-button-green" label={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.GO_TO_APPOINTMENTS,{lng:tgtLangST})}</Trans>} onClick={this.navigateToUpcomingAppointments.bind(this)} /></Col>
            </Row>
          </div>
        }</>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer.user_details,
    data:state.appointmentReducer.data,
    isChatOpened : state.loginReducer.isChatOpened,
    includePrimeLang: state.loginReducer.includePrimeLang,
    label_color_theme: state.dashboardReducer.label_color_theme,
  };
};
const mapDispatchToProps = {
  setPatientConsultationTab,
  setAppData,
  setIsChatOpened,
  setDoctorSelectedData
};
export default connect(mapStateToProps, mapDispatchToProps)(
  withTranslation()(AppointmentConfirmation)
);
